module.exports = __webpack_public_path__ + "img/CAL-IEC-voltage.f13db0d8.webp";